<script lang="ts">
	import { os, app } from 'src/stores/session/native-bridge';
import { app_icon } from 'src/stores/session/preferences';
	import { Alert, CardGrid, DashSelectCard } from '@Shelly/shelly-design-system';
	import { change_app_icon_android } from '../../../services/native_container_requests_android';
	import { change_app_icon_ios } from '../../../services/native_container_requests_ios';
	import { format } from 'svelte-i18n';
	import { save_home } from 'src/helpers/home_helpers';
	import { isDecember } from 'src/configs/modals/AppIconModalConfig';
	export let isInModal = false;

	const isAndroid = $os !== '' && $os !== 'IOS';

	let icons = [
		{
			id: 'default',
			src: 'images/ShellyAppIcon.png',
			name: 'Default',
		},
		...(isDecember()
			? [
					{
						id: 'Icon-Christmas2025',
						src: 'images/Icon-Christmas2025.png',
						name: 'Christmas',
					},
				]
			: []),
	];

	let selectedIconId = $app_icon || 'default';

	const changeIcon = async (iconId: string) => {
		if (!$app) return;

		selectedIconId = iconId;

		if (iconId === 'Icon-Christmas2025') {
			save_home('christmasIcon2025', { set: Date.now() });
		}

		if ($os === 'IOS') {
			change_app_icon_ios(iconId);
		} else if ($os !== '') {
			change_app_icon_android(iconId);
		}

		app_icon.set(iconId);
	};
</script>

{#if isAndroid}
	<Alert
		class="mt-m"
		type="info"
		heading={$format('alert_info_app_icon_setting_android', {
			default: 'Changing the app icon will apply after restart of the app.',
		})}
	/>
{/if}

<CardGrid class="mt-m" sm={140} md={150} xl={190}>
	{#if !isInModal}
		{#each icons as icon (icon.id)}
			<DashSelectCard
				selected={selectedIconId === icon.id}
				class="d-flex min-width-0"
				title={icon.name}
				image={icon.src}
				on:click={() => changeIcon(icon.id)}
			/>
		{/each}
	{:else}
		<div class="d-flex">
			<DashSelectCard
				selected={selectedIconId === icons[0].id}
				class="d-flex min-width-0 mr-s"
				title={icons[0].name}
				image={icons[0].src}
				on:click={() => changeIcon(icons[0].id)}
			/>

			<DashSelectCard
				selected={selectedIconId === icons[1].id}
				class="d-flex min-width-0 ml-s"
				title={icons[1].name}
				image={icons[1].src}
				on:click={() => changeIcon(icons[1].id)}
			/>
		</div>
	{/if}
</CardGrid>
